import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

const ThreeDCarousel = ({ items, centerIndex, setCenterIndex }: any) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const rotationRef = useRef(0);
    const radius = 180;

    useEffect(() => {

        const container = containerRef.current;
        if (!container) return;

        const elements = gsap.utils.toArray<HTMLDivElement>(".carousel-item");
        const totalItems = elements.length;
        const angleStep = 360 / totalItems;

        const updateItems = () => {
            elements.forEach((el, i) => {
                const angle = (i * angleStep + rotationRef.current) % 360;
                const radian = (angle * Math.PI) / 180;
                const x = radius * Math.sin(radian);
                const z = radius * Math.cos(radian);

                gsap.to(el, {
                    x,
                    z,
                    rotateY: 0,
                    duration: 0.6,
                    ease: "power2.out",
                });

                const isCenter = Math.abs((angle + 360) % 360) < angleStep / 2;
                gsap.to(el, {
                    scale: isCenter ? 1.2 : .9,
                    opacity: isCenter ? 1 : 0.5,
                    duration: 0.6,
                    ease: "power2.out",
                });

                if (isCenter) {
                    setCenterIndex(i);
                }
            });
        };

        const handleScroll = (e: WheelEvent) => {
            e.preventDefault();
            const direction = e.deltaX > 0 ? 1 : -1;
            rotationRef.current -= direction * angleStep;
            updateItems();
        };

        let startX = 0;
        const handleTouchStart = (e: TouchEvent) => {
            startX = e.touches[0].clientX;
        };

        const handleTouchEnd = (e: TouchEvent) => {
            const deltaX = e.changedTouches[0].clientX - startX;
            if (Math.abs(deltaX) > 50) {
                const direction = deltaX > 0 ? -1 : 1;
                rotationRef.current -= direction * angleStep;
                updateItems();
            }
        };

        updateItems();
        container.addEventListener("wheel", handleScroll);
        container.addEventListener("touchstart", handleTouchStart);
        container.addEventListener("touchend", handleTouchEnd);

        return () => {
            container.removeEventListener("wheel", handleScroll);
            container.removeEventListener("touchstart", handleTouchStart);
            container.removeEventListener("touchend", handleTouchEnd);
        };
    }, [centerIndex, setCenterIndex]);

    return (
        <div
            ref={containerRef}
            className="carousel-touch"
        >
            {items.map((item: any, index: any) => (
                <div
                    key={index}
                    className="carousel-item"
                >
                    <img
                        src={item.icon}
                        alt={item.title}
                        className="carousel-item_images"
                    />
                    <div className="carousel-item_title">{item.title}</div>
                    <div className="carousel-item_subtitle">
                        {item.subtitle}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ThreeDCarousel;
